import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { useDispatch } from "react-redux";
import { useState } from "react";
import MarkAsReviewedForm from "../ReviewedPlaylistForm/ReviewedPlaylistForm";
import SideModal from "../../../../components/SideModal";
import { useTheme } from "@mui/material/styles";

const PlaylistActionCell = ({
  id,
  row,
  detailPanelRowId,
  setDetailPanelRowId,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const apiRef = useGridApiContext();
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const isReviewRequired = row.status === "review_required";

  const handleOpenDetailPanel = () => {
    apiRef.current.toggleDetailPanel(id);
  };

  const handleOpenReviewModal = () => {
    setOpenReviewModal(true);
  };

  return (
    <>
      <Box sx={{ display: "flex", gap: 1, paddingTop: 0.6 }}>
        <Tooltip title="Open Playlist Page">
          <IconButton
            size="small"
            sx={{
              color: theme.palette.text.primary,
            }}
            onClick={() =>
              navigate(`/playlists/${id}`, {
                state: { name: row.name },
              })
            }
          >
            <ChevronRightIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="View Summary">
          <IconButton size="small" onClick={handleOpenDetailPanel}            sx={{
              color: theme.palette.text.primary,
            }}>
            <InfoIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Mark as Reviewed">
          <IconButton
            size="small"
            onClick={handleOpenReviewModal}
            disabled={!isReviewRequired}            sx={{
              color: theme.palette.text.primary,
            }}
          >
            <CheckCircleIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <SideModal
        open={openReviewModal}
        onClose={() => setOpenReviewModal(false)}
        title="Mark Playlist as Reviewed"
      >
        <MarkAsReviewedForm
          playlistId={id}
          playlistName={row.name}
          onSubmit={() => setOpenReviewModal(false)}
        />
      </SideModal>
    </>
  );
};

export default PlaylistActionCell;
